type LanguageOption = { code: string; label?: string; detail?: string };

export function LanguageFlagSelector({ languages, value, onChange, label = "Seleccionar idioma", loading = false }: { languages: Array<string | LanguageOption>; value: string; onChange: (language: string) => void; label?: string; loading?: boolean }) {
  const options = languages.map((item) => typeof item === "string" ? { code: item } : item).filter((item, index, all) => item.code && all.findIndex((candidate) => candidate.code.toLowerCase() === item.code.toLowerCase()) === index);
  return <div className="language-flag-selector" role="group" aria-label={label} data-no-translate>
    {options.map((option) => {
      const title = [option.label || languageName(option.code), option.detail].filter(Boolean).join(" · ");
      const active = sameLanguage(option.code, value);
      return <button type="button" className={active ? "active" : ""} aria-pressed={active} aria-label={title} title={title} onClick={() => onChange(option.code)} key={option.code}>
        <span aria-hidden="true">{active && loading ? <i className="language-loading" /> : languageFlag(option.code)}</span><small>{languageShortCode(option.code)}</small>
      </button>;
    })}
  </div>;
}

function sameLanguage(first: string, second: string) { return first.toLowerCase().replace("_", "-") === second.toLowerCase().replace("_", "-"); }
export function languageShortCode(code: string) { return code.split(/[-_]/)[0].toUpperCase(); }
export function languageName(code: string) {
  try { return new Intl.DisplayNames(["es"], { type: "language" }).of(code) || code.toUpperCase(); }
  catch { return code.toUpperCase(); }
}
export function languageFlag(code: string) {
  const normalized = code.toLowerCase().replace("_", "-");
  const region = normalized.split("-")[1];
  if (region?.length === 2) return region.toUpperCase().replace(/[A-Z]/g, (letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)));
  return ({ es: "🇪🇸", en: "🇬🇧", pt: "🇧🇷", fr: "🇫🇷", de: "🇩🇪", it: "🇮🇹", ca: "🇦🇩", eu: "🇪🇺", gl: "🇪🇸", nl: "🇳🇱", ru: "🇷🇺", uk: "🇺🇦", pl: "🇵🇱", cs: "🇨🇿", el: "🇬🇷", tr: "🇹🇷", ar: "🇸🇦", he: "🇮🇱", hi: "🇮🇳", zh: "🇨🇳", ja: "🇯🇵", ko: "🇰🇷" } as Record<string, string>)[normalized.split("-")[0]] || "🌐";
}
